import type { PresentPerson } from "../../../api/content/reviewCollaborationApi";

/** Who is here, in words (curation-ui.md CU-10 presence), pure. */

/** The names of the others who have the review open at `unitKey`. */
export function othersAt(present: readonly PresentPerson[], unitKey: string, viewer: string | null, nameOf: (userId: string) => string): readonly string[] {
  return present.filter((person) => person.unitKey === unitKey && person.userId !== viewer).map((person) => nameOf(person.userId));
}
